import { getLiveList } from '@api/liveList';
export default {
    state: {
        liveList: []
    },
    mutations: {
        SET_LIVELIST(state, data) {
            state.liveList = data;
        }
    },
    actions: {
        async queryLiveList({ commit }) {
            const { code, data, msg } = await getLiveList();
            const liveList = data;
            if (code === 0) {
                commit('SET_LIVELIST', liveList);
            } else {
                return Promise.reject(new Error(msg));
            }
        }
    }
};
